import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  rem,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconEye, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryMaster } from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { cobalt_blue, gray, sky_blue } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { UserMenuGroup } from "../../model/UserMenuGroup";
import { _validateMenuValidator } from "../../validate/UserCreateModelValidator";

const MenuGroupEdit = function ({
  id,
  onLoad,
}: {
  id: number;
  onLoad: () => Promise<void>;
}) {
  const entity: UserMenuGroup = {
    id: id,
    name: "",
  };
  const form = useForm<UserMenuGroup>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: _validateMenuValidator,
  });

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const apiCreate = async (data: UserMenuGroup) => {
    open();
    let urlCreate = `/api/v1/menugroup/edit`;
    const callapi = await repositoryMaster.post(urlCreate, data);
    if (callapi)
      if (callapi?.success) {
        modals.closeAll();
        await onLoad();
        NotificationExtension.Success("Chỉnh sửa thành công !");
      } else if (callapi != null)
        NotificationExtension.Fails("Chỉnh sửa thất bại !");
    close();
  };
  useEffect(() => {
    callApiGetData();
  }, []);
  const [showPass, SetShowPass] = useState<boolean>(false);

  const callApiGetData = async () => {
    open();
    let urlCreate = `/api/v1/menugroup/edit?id=` + id;
    const callapi = await repositoryMaster.get<MessageResponse<UserMenuGroup>>(
      urlCreate
    );
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };
  return (
    <>
      <Box
        component="form"
        onSubmit={form.onSubmit(async (e: UserMenuGroup) => {
          await apiCreate(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Box className="flex-none" component="form" mx="auto">
          <Grid>
            <Grid.Col span={{ base: 12 }}>
              <TextInput
                label="Tên nhóm: "
                placeholder="Nhập..."
                withAsterisk
                {...form.getInputProps("name")}
              />
            </Grid.Col>
          </Grid>
          <Checkbox
            mt={"xs"}
            key={form.key("active")}
            label="Trạng thái"
            defaultValue={form.getValues().active ?? false}
            defaultChecked={form.getValues().active ?? false}
            {...form.getInputProps("active")}
          />
        </Box>
        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default MenuGroupEdit;
